import { Injectable } from '@angular/core';

@Injectable()
export class UiService {
   public togglePageLoader(isLoading: boolean): void {
       document.getElementById('preloader').style.display = isLoading ? 'block' : 'none';
   }
}
